/* Estimated delivery dates. An element with data-mj-eta gets a date range:
   data-dispatch="min,max" in working days (Mon–Fri), data-transit="min,max" in calendar days. */
(function () {
  function addWorkdays(d, n) {
    var r = new Date(d);
    while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; }
    return r;
  }
  function addDays(d, n) { var r = new Date(d); r.setDate(r.getDate() + n); return r; }
  function weekday(d) { var r = new Date(d); while (r.getDay() === 0 || r.getDay() === 6) r.setDate(r.getDate() + 1); return r; }
  function fmt(d, withMonth) { return d.toLocaleDateString('en-US', withMonth ? { month: 'short', day: 'numeric' } : { day: 'numeric' }); }
  function range(a, b) {
    if (a.getMonth() === b.getMonth()) return fmt(a, true) + ' – ' + fmt(b, false);
    return fmt(a, true) + ' – ' + fmt(b, true);
  }
  function fill(root) {
    (root || document).querySelectorAll('[data-mj-eta]:not([data-mj-eta-done])').forEach(function (el) {
      var dsp = (el.getAttribute('data-dispatch') || '1,3').split(',').map(Number);
      var trn = (el.getAttribute('data-transit') || '6,8').split(',').map(Number);
      var now = new Date();
      var from = weekday(addDays(addWorkdays(now, dsp[0]), trn[0]));
      var to = weekday(addDays(addWorkdays(now, dsp[1]), trn[1]));
      el.textContent = range(from, to);
      el.setAttribute('data-mj-eta-done', '');
    });
  }
  window.mjEtaFill = fill;
  function start() {
    fill();
    var t = 0;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(fill, 60); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
